import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import {HTTP} from './http-common'
Vue.prototype.$http = HTTP

import uk from 'vee-validate/dist/locale/uk';
import VeeValidate, { Validator } from 'vee-validate';
// Install the Plugin.
Vue.use(VeeValidate);
// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('uk', uk);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
